import { Component, inject, ResourceRef } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { rxResource } from '@angular/core/rxjs-interop';
import { SettingSearchResponseDto, SettingService } from '@millionshow/api-client';
import { toSignal } from '@angular/core/rxjs-interop';
import { NavigationEnd } from '@angular/router';
import { filter, map, startWith } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import { SnsButtonsComponent } from '../../../components/sns-buttons/sns-buttons.component';

@Component({
  selector: 'app-footer',
  imports: [RouterLink, CommonModule, SnsButtonsComponent],
  templateUrl: './footer.component.html',
})
export default class FooterComponent {
  private readonly settingService = inject(SettingService);
  private readonly router = inject(Router);

  readonly disclaimer =
    '(주)마이스좋은공간은 박람회 및 행사 기획·운영을 담당하며, 판매의 당사자가 아닙니다. 행사 참가업체가 제공하는 상품 및 배송, 환불에 관한 책임은 해당 업체에 있습니다.';

  $data: ResourceRef<SettingSearchResponseDto | undefined> = rxResource({
    stream: () =>
      this.settingService.settingControllerSearch({
        pageNo: 1,
        pageSize: 100,
        query: 'allhouse',
      }),
  });

  logoData = toSignal(
    this.settingService.settingControllerFindByKey({ key: 'allhouse_logo_url' })
  );

  isHomePage = toSignal(
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      map(() => this.router.url === '/' || this.router.url === ''),
      startWith(this.router.url === '/' || this.router.url === '')
    ),
    { initialValue: this.router.url === '/' || this.router.url === '' }
  );

  getSettingValue(key: string): string {
    const items = this.$data.value()?.items;
    const item = items?.find(item => item.key === key);
    return item?.value || '';
  }
}
